function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Select
 * 
 */
import * as React from 'react';
import ErrorMessage from '../error-message/ErrorMessage';
import Info from '../info/Info';
import './Select.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class Select extends React.Component {
  constructor(...args) {
    super(...args);
    /**
     * Match state from display or value
     */
    _defineProperty(this, "matchState", () => {
      const {
        name,
        options,
        values
      } = this.props;
      let {
        display,
        value
      } = values[name];
      for (let i = 0; i < options.length; i++) {
        const option = options[i];
        switch (true) {
          case display === option.value:
            return display;
          case value === option.value:
            return value;
          default:
          // no op
        }
      }
    });
  }
  /**
   * Render the options
   */
  renderOptions() {
    const {
      handleChange,
      name,
      onBlur,
      options,
      section,
      values
    } = this.props;
    if (options.length === 0) {
      return null;
    }
    const id = section ? `${section}_${name}` : name;
    const value = values[name] && values[name].value ? values[name].value : '';
    let i = 0;
    return /*#__PURE__*/_jsx("select", {
      id: id,
      name: id,
      onBlur: e => onBlur(e.target.value),
      onChange: e => handleChange(e.target.value),
      value: value,
      children: options.map(item => {
        return /*#__PURE__*/_jsx("option", {
          value: item.value,
          children: item.title
        }, i++);
      })
    });
  }
  render() {
    let {
      errorMessage,
      info,
      label,
      name,
      options,
      section,
      values
    } = this.props;
    const {
      error,
      required,
      valid,
      value
    } = values[name] ? values[name] : {
      display: '',
      error: false,
      required: false,
      valid: null,
      value: ''
    };
    const id = section ? `${section}_${name}` : name;
    errorMessage = errorMessage === '' ? `${label} is required` : errorMessage;
    if (options.length === 0) {
      return null;
    }
    const classes = ['form-element-container', name, value === '' ? 'default' : '', error ? 'error' : '', valid === true ? 'valid' : ''];
    return /*#__PURE__*/_jsxs("div", {
      className: classes.join(' ').trim(),
      children: [/*#__PURE__*/_jsxs("label", {
        htmlFor: id,
        children: [label, required && id !== 'personal-details_autoClub' ? /*#__PURE__*/_jsx("span", {
          className: "required",
          children: "*"
        }) : '']
      }), this.renderOptions(), /*#__PURE__*/_jsx(ErrorMessage, {
        message: errorMessage,
        error: error
      }), info.length > 0 ? /*#__PURE__*/_jsx(Info, {
        info: info
      }) : null]
    });
  }
}
_defineProperty(Select, "defaultProps", {
  errorMessage: '',
  info: '',
  label: 'select',
  handleChange: () => null,
  name: 'title',
  onBlur: () => null,
  options: [{
    title: '--',
    value: '0'
  }],
  required: false,
  section: 'personal-details'
});
export default Select;